import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faCheckCircle,
  faRedo,
  faPowerOff,
  faUserCircle,
  faPen,
  faEllipsisH,
  faColumns,
  faSync,
  faTimes,
  faSort,
  faSortUp,
  faSortDown,
  faFilter,
  faInfoCircle,
  faSpinner,
  faExclamationTriangle,
  faExclamationCircle,
  faChevronUp,
  faChevronRight,
  faChevronDown,
  faChevronLeft,
  faUserCog,
  faUserCheck,
  faUserGraduate,
  faUserSlash,
  faUserClock,
  faUser,
  faSlash,
  faEnvelope,
  faBan,
  faUserTimes,
  faEdit,
  faAt,
  faCalendarCheck,
  faCalendarTimes,
  faCalendarDay,
  faQuestion,
  faIdCard,
  faIdCardAlt,
  faUsers,
  faBuilding,
  faCogs,
  faHome,
  faBoxes,
  faDatabase,
  faCircle,
  faSlidersH,
  faUndo,
  faSearch,
  faEquals,
  faTrashAlt,
  faPlus,
  faUserTie,
  faUserSecret,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

const icons = {
  faCheck,
  faCheckCircle,
  faRedo,
  faPowerOff,
  faUserCircle,
  faPen,
  faEllipsisH,
  faColumns,
  faSync,
  faTimes,
  faSort,
  faSortUp,
  faSortDown,
  faFilter,
  faInfoCircle,
  faSpinner,
  faExclamationTriangle,
  faExclamationCircle,
  faChevronUp,
  faChevronRight,
  faChevronDown,
  faChevronLeft,
  faUserCog,
  faUserCheck,
  faUserGraduate,
  faUserSlash,
  faUserClock,
  faUser,
  faSlash,
  faEnvelope,
  faBan,
  faUserTimes,
  faEdit,
  faAt,
  faCalendarCheck,
  faCalendarTimes,
  faCalendarDay,
  faQuestion,
  faIdCard,
  faIdCardAlt,
  faUsers,
  faBuilding,
  faCogs,
  faHome,
  faBoxes,
  faDatabase,
  faCircle,
  faSlidersH,
  faUndo,
  faSearch,
  faEquals,
  faTrashAlt,
  faPlus,
  faUserTie,
  faUserSecret,
  faGlobe,
};

let initialized = false;

const initializer = {
  init: () => {
    if (!initialized) {
      library.add(...Object.values(icons));
      initialized = true;
    }
  },
  icons,
};

export default initializer;
